module.exports = __webpack_public_path__ + "static/20-13-2323146b017908e271c70c6c3d0ff6b6.jpg";